import { createUserWithEmailAndPassword } from 'firebase/auth';
import React, { FormEvent, useState } from 'react';
import { useNavigate, Link as NavLink } from 'react-router-dom';
import Button from '@mui/material/Button';
import AuthContainer from '../../components/AuthContainer';
import ErrorText from '../../components/ErrorText';
import { auth } from '../../config/firebase';
import Link from '@mui/material/Link';
import logging from '../../config/logging';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';

const RegisterPage: React.FC = props => {
  const [registering, setRegistering] = useState<boolean>(false);
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [passwordConfirm, setPasswordConfirm] = useState<string>('');
  const [error, setError] = useState<string>('');

  const navigate = useNavigate();

  const handleSignUp = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (password !== passwordConfirm) {
      setError('Please make sure your passwords match.');
      return;
    }

    if (error !== '') setError('');

    setRegistering(true);

    createUserWithEmailAndPassword(auth, email, password)
      .then(result => {
        logging.info(result);
        navigate('/login');
      })
      .catch(error => {
        logging.error(error);

        if (error.code.includes('auth/weak-password')) {
          setError('Please enter a stronger password.');
        } else if (error.code.includes('auth/email-already-in-use')) {
          setError('Email already in use.');
        } else {
          setError('Unable to register.  Please try again later.');
        }

        setRegistering(false);
      });
  };

  const handleChangeEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();

    setEmail(e.target.value);
  }
  const handleChangePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();

    setPassword(e.target.value);
  }
  const handleChangePasswordConfirm = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();

    setPasswordConfirm(e.target.value);
  }

  return (
    <Container component='main' maxWidth='xs'>
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component='h1' variant='h5'>
          Sign up
        </Typography>
        <Box
          component='form'
          onSubmit={handleSignUp}
          noValidate sx={{ mt: 1 }}
        >
          <TextField
            margin='normal'
            required
            fullWidth
            id='email'
            label='Email Address'
            name='email'
            autoComplete='email'
            autoFocus
            onChange={handleChangeEmail}
          />
          <TextField
            margin='normal'
            required
            fullWidth
            name='password'
            label='Password'
            type='password'
            id='password'
            onChange={handleChangePassword}
          />
          <TextField
            margin='normal'
            required
            fullWidth
            name='password_confirm'
            label='Password confirm'
            type='password'
            id='password_confirm'
            onChange={handleChangePasswordConfirm}
          />
          { error && (
            <Grid my={2} display='flex' justifyContent='center' container>
              <ErrorText error={error} />
            </Grid>
          ) || null}
          <Button
            type='submit'
            fullWidth
            variant='contained'
            sx={{ mt: 3, mb: 2 }}
          >
            Sign Up
          </Button>
          <Grid display='flex' justifyContent='center' container>
            <Grid item>
              <NavLink to='/login' >
                <Link href='#' variant='body2'>
                  {'Already have an account? Sign in'}
                </Link>
              </NavLink>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Container>
  );
};

export default RegisterPage;